module.exports = __webpack_public_path__ + "static/media/block.e0d8beb5.svg";